import axios from 'axios';

export const WORKFLOW_API = '/api/etl_module/data-workflows/';

export function isWorkflowShaped(studioConfig) {
  const sc = studioConfig || {};
  return !!sc.workflow_id && !(sc.steps || []).length;
}

export async function loadConsumerWorkflow(studioConfig) {
  const sc = studioConfig || {};
  if (!isWorkflowShaped(sc)) return { workflow: null, steps: (sc.steps || []).map((s) => ({ ...s })) };
  const { data } = await axios.get(`${WORKFLOW_API}${sc.workflow_id}/`);
  const workflow = toRecipe(data);
  if (workflow.isWrapper) return { workflow, steps: [{ workflow_id: data.id }] };
  const steps = ((data.approved_snapshot || {}).studio_config || {}).steps || [];
  return { workflow, steps: steps.map((s) => ({ ...s })) };
}

export function toRecipe(data) {
  return {
    id: data.id,
    name: data.name || '',
    description: data.description || '',
    isWrapper: !!data.is_wrapper,
    usedBy: data.used_by || {},
  };
}

export function usedBySummary(usedBy) {
  const labels = {
    metrics: 'metric', worklists: 'worklist', flags: 'flag', insights: 'insight',
    opportunities: 'opportunity config', workflows: 'workflow', hermes_templates: 'Hermes template',
    suspect_rules: 'suspect rule', agent_pages: 'page', hermes_runs: 'open Hermes run',
  };
  const parts = Object.entries(usedBy || {})
    .filter(([, ids]) => (ids || []).length)
    .map(([kind, ids]) => `${ids.length} ${labels[kind] || kind}${ids.length === 1 ? '' : 's'} (${ids.slice(0, 8).join(', ')}${ids.length > 8 ? ', …' : ''})`);
  return { count: Object.values(usedBy || {}).reduce((n, ids) => n + (ids || []).length, 0), text: parts.join('; ') };
}

export async function consumerSteps(studioConfig) {
  return (await loadConsumerWorkflow(studioConfig)).steps;
}

export function withoutSteps(studioConfig) {
  const out = { ...(studioConfig || {}) };
  delete out.steps;
  return out;
}

export async function publishWorkflowSteps(workflowId, steps) {
  const { data } = await axios.post(`${WORKFLOW_API}${workflowId}/publish/`, { studio_config: { steps } });
  return data;
}

export async function createSharedWorkflow(name, steps) {
  const { data } = await axios.post(WORKFLOW_API, {
    name,
    studio_config: { steps },
    expected_cadence: 'none',
  });
  return publishWorkflowSteps(data.id, steps);
}
